import { useMutation } from '@apollo/client';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.js';
import { gql } from '@/__generated__';
import { AiFilter } from './types';

const DELETE_AI_FILTER = gql(`
  mutation RemoveAIFilter($id: ID!) {
    removeAIFilter(id: $id)
  }
`);

export function useDeleteAiFilter(filter: AiFilter) {
  const toast = useToast();

  const [deleteFilter, { loading }] = useMutation(DELETE_AI_FILTER, {
    update(cache) {
      cache.modify({
        fields: {
          aiFilters(existingFilters = [], { readField }) {
            return existingFilters.filter(
              (filterRef: { __ref: string }) =>
                readField('id', filterRef) !== filter.id,
            );
          },
        },
      });
      cache.evict({
        fieldName: 'customCollections',
      });
      cache.evict({
        fieldName: 'aiFilters',
      });
      cache.gc();
    },
    onCompleted: () => {
      toast.success({
        title: `Filter ${filter.name} deleted`,
      });
    },
    onError: () => {
      toast.error({
        title: 'Failed to delete AI filter',
        subTitle: 'Please try again',
      });
    },
  });

  return { deleteFilter, loading };
}
